import type { ComponentTemplate } from "schemas/generated/componentTemplates";

export const dynamicBundle: ComponentTemplate = {
  id: "35c6a2e2-b0cd-407f-b673-ec1a277bffe6",
  storeId: null,

  scope: "left-bar",
  type: "component",
  name: "Rebuy/Rebuy Dynamic Bundle",
  leftBarCategory: { main: "pageIntegrations", subCategory: "rebuy" },
  preview: "rebuy/dynamic-bundle.svg",
  transforms: [],
  template: {
    id: "$uid",
    type: "rebuyWidget",
    props: {
      style: {
        alignSelf: "stretch",
        flexGrow: 1,
      },
    },
  },
};
